module.exports = __webpack_public_path__ + "img/Insanity.2a3133b1.png";